/* VAULT - search.js — modal + predictive */
(function(){
  'use strict';
  if(!window.Vault) return;
  var V = window.Vault;
  var routes = (window.VAULT && VAULT.routes) || {};

  var modal = V.$('[data-search-modal]');
  var input = V.$('[data-search-input]');
  var clearBtn = V.$('[data-search-clear]');
  var results = V.$('[data-search-results]');
  var heading = V.$('[data-results-heading]');

  function openModal(){
    if(!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('no-scroll');
    setTimeout(function(){ if(input) input.focus(); }, 80);
  }
  function closeModal(){
    if(!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('search:open', openModal);
  document.addEventListener('search:close', closeModal);

  // Click outside the panel closes
  V.on(modal,'click',function(e){
    if(e.target === modal) closeModal();
  });

  function renderResults(data){
    if(!results) return;
    var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    // Clear previous results
    while(results.firstChild) results.removeChild(results.firstChild);
    if(products.length === 0){
      var empty = document.createElement('p');
      empty.className = 'text-mute';
      empty.style.cssText = 'font-size:13px;padding:8px 0;';
      empty.textContent = 'No results — try a different term.';
      results.appendChild(empty);
      return;
    }
    products.forEach(function(p){
      var a = document.createElement('a');
      a.className = 'search-modal__product';
      a.href = p.url || '#';
      if(p.available === false) a.classList.add('is-unavailable');
      var imgWrap = document.createElement('div');
      imgWrap.className = 'search-modal__product-img';
      // Predictive search may expose the image as `featured_image.url` or as a plain `image` string.
      var imgSrc = (p.featured_image && p.featured_image.url) || p.image || '';
      if(imgSrc){
        var img = document.createElement('img');
        // Append width param safely; Shopify CDN URLs accept ?width=N
        img.src = imgSrc + (imgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=120';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 48; img.height = 48;
        imgWrap.appendChild(img);
      }
      a.appendChild(imgWrap);
      var info = document.createElement('div');
      info.className = 'search-modal__product-info';
      var title = document.createElement('div');
      title.className = 'search-modal__product-title';
      title.textContent = p.title || '';
      var price = document.createElement('div');
      price.className = 'search-modal__product-price';
      if(p.available === false){
        price.textContent = 'Sold out';
        price.classList.add('search-modal__product-price--sold');
      } else {
        // Show a "From $X" when the product spans multiple price points.
        var hasRange = p.price_min != null && p.price_max != null &&
                       parseFloat(p.price_min) !== parseFloat(p.price_max);
        var base = (p.price_min != null) ? p.price_min : p.price;
        var formatted = formatPredictivePrice(base);
        price.textContent = formatted ? (hasRange ? 'From ' + formatted : formatted) : '';
      }
      info.appendChild(title);
      info.appendChild(price);
      a.appendChild(info);
      results.appendChild(a);
    });
  }

  // The Predictive Search API returns prices as a DOLLAR string (e.g. "315.00"),
  // not cents. V.formatMoney expects cents, so multiply by 100 before formatting.
  // Falls back gracefully if the value is missing or non-numeric.
  function formatPredictivePrice(value){
    if(value === null || value === undefined || value === '') return '';
    var dollars = parseFloat(value);
    if(isNaN(dollars)) return '';
    return V.formatMoney(Math.round(dollars * 100));
  }

  var doSearch = V.debounce(function(query){
    if(!query || query.length < 2){
      if(results) results.innerHTML = '';
      if(heading) heading.textContent = 'Popular right now';
      return;
    }
    if(heading) heading.textContent = 'Results for "' + query + '"';
    var url = (routes.predictiveSearch || '/search/suggest.json') +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[options][unavailable_products]=last' +
      '&resources[limit]=6';
    fetch(url, {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(renderResults)
      .catch(function(){
        if(results) results.innerHTML = '<p class="text-mute" style="font-size:13px;padding:8px 0;">Search unavailable.</p>';
      });
  }, 220);

  V.on(input,'input',function(){
    var v = this.value.trim();
    if(clearBtn) clearBtn.hidden = !v;
    doSearch(v);
  });

  if(clearBtn){
    V.on(clearBtn,'click',function(){
      if(!input) return;
      input.value = '';
      clearBtn.hidden = true;
      input.focus();
      doSearch('');
    });
  }
})();
